import { makeRecord } from "sdi/source";
import { fromRecord } from "sdi/locale";

export function attribution() {
  return `Géoportail de l'hydroélectricité en RDC`;
}

export function credits() {
  return fromRecord(makeRecord("Fond de plan: \n(c) OpenStreetMap"));
}
